function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Avatar INSTEAD.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from "../Icon";

/* eslint-disable react/forbid-prop-types */

/**
 * Avatar Component
 */
var Avatar = /*#__PURE__*/function (_Component) {
  function Avatar(props) {
    var _this;
    _classCallCheck(this, Avatar);
    _this = _callSuper(this, Avatar, [props]);
    _this.state = {
      imageStatus: 'loading',
      hasFallback: props.fallbackIcon
    };
    _this.handleImageLoaded = _this.handleImageLoaded.bind(_this);
    return _this;
  }
  _inherits(Avatar, _Component);
  return _createClass(Avatar, [{
    key: "handleImageLoaded",
    value: function handleImageLoaded() {
      this.setState({
        imageStatus: 'loaded'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        alt = _this$props.alt,
        className = _this$props.className,
        fallbackIcon = _this$props.fallbackIcon,
        id = _this$props.id,
        image = _this$props.image,
        shouldRender = _this$props.shouldRender,
        size = _this$props.size,
        style = _this$props.style;
      var _this$state = this.state,
        imageStatus = _this$state.imageStatus,
        hasFallback = _this$state.hasFallback;
      if (!shouldRender) {
        return null;
      }
      var avatarClass = function avatarClass() {
        return classNames({
          'avatar--loading': imageStatus === 'loading' && !hasFallback,
          'avatar--large': size === 'lg',
          'avatar--small': size === 'sm',
          avatar: true
        }, className);
      };
      return /*#__PURE__*/React.createElement("figure", {
        id: id,
        "data-role": "avatar",
        style: style,
        className: avatarClass()
      }, /*#__PURE__*/React.createElement("img", {
        className: fallbackIcon && !image ? 'hidden' : '',
        alt: alt,
        src: image,
        onLoad: this.handleImageLoaded
      }), fallbackIcon && !image && /*#__PURE__*/React.createElement(Icon, {
        className: "avatar__fallback-icon",
        icon: fallbackIcon
      }));
    }
  }]);
}(Component);
Avatar.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Conditional logic to determine if render */
  shouldRender: PropTypes.bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Image to display */
  image: PropTypes.string,
  /** Alt text for the image */
  alt: PropTypes.string,
  /** Predefined avatar size */
  size: PropTypes.oneOf(['lg', 'md', 'sm']),
  /** Fallback icon for when the image is missing */
  fallbackIcon: PropTypes.string
};
Avatar.defaultProps = {
  id: '',
  className: '',
  image: '',
  alt: 'Avatar Image',
  shouldRender: true,
  size: 'md',
  style: {},
  fallbackIcon: null
};
export default Avatar;